import { createSelector } from '@reduxjs/toolkit';
import { getTermsValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectCoworkingOfferType = createSelector(selectJsonQuery, jsonQuery =>
  getTermsValue('coworking_offer_type')(jsonQuery),
);
